import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { apiUrl, fileApiUrl } from '../../../config/apiConfig';
import { useUser } from '../../../contexts/userContext';
import { useColumns } from '../../../contexts/columnsContext';
import { useCard } from '../../../contexts/cardContext';
import './style.css';
import api from '../../../services/api';
import apiUploads from '../../../services/apiUploads';
import { formatBrazilianPhoneInput } from '../../../utils/phoneFormatter';
import { validateCardPhone } from '../../../utils/phoneValidation';
import WhatsappZapiContactPicker from '../../WhatsappZapi/WhatsappZapiContactPicker';

// API URL for IBGE
const apiUrlIbge = 'https://servicodados.ibge.gov.br/api/v1/localidades';
const sanitizeCardName = (value) => String(value ?? '').replace(/\//g, '');

const isCardPart = (card) =>
  Boolean(card?.card_original_id) ||
  Number(card?.etapa_producao) > 0 ||
  /^(pt|parte)[\s-]*(?:0*[2-9]|0*[1-9][0-9]+)(?:$|[^0-9])/i.test(
    String(card?.name ?? '').trim()
  );

const getEmptyParticipantForm = () => ({
  name: '',
  email: '',
  telefone: '',
  endereco: '',
  tipo: 'Cliente',
  state: '',
  city: '',
  cpf: '',
});

function UpdateCard({ idCard, cardData }) {
  const { user, listAllUsers, empresa } = useUser();
  const { columnsUser, columns, listaEtiquetas, editableColumns } = useColumns();
  const { addHistoricoCardContext, setOpenCloseUpdateCard, cards, setCards, setPreviewSearchCards, setListNotifications } = useCard();

  const [statusCard, setStatusCard] = useState('');
  const [statusDateCard, setStatusDateCard] = useState(null);
  const [documentNumber, setDocumentNumber] = useState('');
  const [secondDocumentoNumber, setSecondDocumentNumber] = useState('');
  const [pedidoNumber, setPedidoNumber] = useState('');

  const [entityId, setEntityId] = useState();
  const [name, setName] = useState('');
  const [saleValue, setSaleValue] = useState();
  const [costValue, setCostValue] = useState();
  const [initialCostValue, setInitialCostValue] = useState(0);
  const [email, setEmail] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [fone, setFone] = useState('');
  const [columnId, setColumnId] = useState();
  const [error, setError] = useState('');
  const [isUpdatingCard, setIsUpdatingCard] = useState(false);
  const [count, setCount] = useState(0);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [currentIdColumn, setCurrentIdColumn] = useState();
  const [origemCard, setOrigemCard] = useState('');
  const [produtoCard, setProdutoCard] = useState('');

  const [listOrigens, setListOrigens] = useState([]);
  const [listProdutos, setListProdutos] = useState([]);

  const [idEtiqueta, setIdEtiqueta] = useState(0);

  const [cpf, setCpf] = useState('');  // Novo estado para CPF
  const [cpfError, setCpfError] = useState('');  // Novo estado para erros de CPF

  const [endereco, setEndereco] = useState(''); // Novo estado para endereço

  const [participanteId, setParticipanteId] = useState(''); // Mantem compatibilidade com o participante/parceiro antigo do card
  const [cardParticipantesList, setCardParticipantesList] = useState([]);
  const [cardParticipantesMessage, setCardParticipantesMessage] = useState('');
  const [createParticipantOpen, setCreateParticipantOpen] = useState(false);
  const [newParticipantForm, setNewParticipantForm] = useState(getEmptyParticipantForm());
  const [newParticipantSaving, setNewParticipantSaving] = useState(false);
  const [newParticipantMessage, setNewParticipantMessage] = useState('');
  const [newParticipantCpfError, setNewParticipantCpfError] = useState('');
  const participantSearchSelectRef = useRef(null);
  const [participantSearchModal, setParticipantSearchModal] = useState({
    open: false,
    title: 'Buscar participante',
    emptyText: 'Digite ao menos 2 caracteres para buscar.',
    term: '',
    page: 1,
    limit: 8,
    total: 0,
    totalPages: 0,
    items: [],
    loading: false,
    message: '',
    excludeIds: [],
  });

  const [pais, setPais] = useState('Brasil');
  const [cidadeEstadoInternacional, setCidadeEstadoInternacional] = useState('');

  const [clienteRecorrente, setClienteRecorrente] = useState(false);
  const [tipoClienteId, setTipoClienteId] = useState('');
  const [listTiposCliente, setListTiposCliente] = useState([]);


  const [contractSigned, setContractSigned] = useState(false);
  const [contractSignedAt, setContractSignedAt] = useState(null);
  const [contractSignedByUser, setContractSignedByUser] = useState(null);


  const [currentEntity, setCurrentEntity] = useState();
  const [responsavel, setResponsavel] = useState('');


  const [motivoCardArquivado, setMotivoCardArquivado] = useState('');
  const [tempCardData, setTempCardData] = useState(null); // Novo estado para dados temporários

  const cardParticipanteRoles = [
    { value: 'participante', label: 'Participante' },
    { value: 'cliente', label: 'Cliente' },
    { value: 'empresa', label: 'Empresa' },
    { value: 'arquiteto', label: 'Arquiteto' },
    { value: 'construtor', label: 'Construtor' },
    { value: 'parceiro', label: 'Parceiro' },
    { value: 'indicador', label: 'Indicador' },
    { value: 'financeiro', label: 'Financeiro' },
    { value: 'responsavel_obra', label: 'Responsavel obra' },
  ];

  const getParticipantDisplayName = (item) => (
    item?.name
    || item?.participante_name
    || item?.nome
    || item?.email
    || item?.telefone
    || item?.cpf
    || 'Participante sem nome'
  );

  const getParticipantDisplayMeta = (item) => {
    const parts = [
      item?.telefone,
      item?.email,
      item?.cpf,
    ].filter(Boolean);
    return parts.length ? parts.join(' - ') : 'Sem telefone/email';
  };

  // Adicionar useEffect para lidar com a tecla ESC
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        if (participantSearchModal.open) {
          setParticipantSearchModal(prev => ({ ...prev, open: false }));
          return;
        }
        if (createParticipantOpen) {
          setCreateParticipantOpen(false);
          return;
        }
        setOpenCloseUpdateCard(false);
      }
    };

    window.addEventListener('keydown', handleEscKey);

    // Cleanup function para remover o event listener
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [createParticipantOpen, participantSearchModal.open, setOpenCloseUpdateCard]);

  useEffect(() => {
    setCount(count + 1);
    if (count > 1) {
      setIsUpdatingCard(true);
    }
  }, [statusCard, documentNumber, secondDocumentoNumber, pedidoNumber, entityId, name, saleValue, costValue, email, state, city, fone, columnId, origemCard, pais, cidadeEstadoInternacional, clienteRecorrente, tipoClienteId]);


  const formatToBrazilianCurrency = (value) => {
    if (value === undefined || value === null) return '';
    return value.toString().replace('.', ',');
  };

  useEffect(() => {
    if (cardData) {
      // Armazena os dados iniciais
      setTempCardData({
        name: cardData.name,
        email: cardData.email,
        fone: cardData.fone,
        state: cardData.state,
        city: cardData.city,
        document_number: cardData.document_number || '',
        second_document_number: cardData.second_document_number || '',
        pedido_number: cardData.pedido_number || '',
        cost_value: cardData.cost_value,
        sale_value: cardData.sale_value,
        entity_id: cardData.entity_id,
        column_id: cardData.column_id,
        origem: cardData.origem || 'Sem Origem',
        produto: cardData.produto || '',
        cpf: cardData.cpf || '',
        endereco: cardData.endereco || '',
        participante_id: cardData.participante_id || '',
        responsavel: cardData.responsavel || ''
      });

      setDocumentNumber(cardData.document_number || '');


      setSaleValue(formatToBrazilianCurrency(cardData.sale_value)); // Formatar valor de venda
      setCostValue(formatToBrazilianCurrency(cardData.cost_value));
      // Armazenar cost_value inicial - pode ser null, undefined, vazio ou zero
    setInitialCostValue(cardData.cost_value);

      setName(sanitizeCardName(cardData.name));
      setEmail(cardData.email);
      setState(cardData.state);
      setCity(cardData.city);
      setFone(cardData.fone);
      setColumnId(cardData.column_id);
      setEntityId(cardData.entity_id);
      setStatusCard(cardData.status);
      setOrigemCard(cardData.origem ? cardData.origem : 'Sem Origem');
      setProdutoCard(cardData.produto);
      setStatusDateCard(cardData.status_date ? new Date(cardData.status_date).toISOString().split('T')[0] : ''); // Formate a data aqui
      setSecondDocumentNumber(cardData.second_document_number);
      setPedidoNumber(cardData.pedido_number);
      setIdEtiqueta(cardData.etiqueta_id || 0); // Garantir que idEtiqueta seja configurado corretamente
      setCpf(cardData.cpf || ''); // Garantir que idEtiqueta seja configurado corretamente
      setEndereco(cardData.endereco || '');
      setParticipanteId(cardData.participante_id || '');
      setCidadeEstadoInternacional(cardData.cidade_estado_internacional || '');
      setPais(cardData.pais || 'Brasil');

      setClienteRecorrente(cardData.cliente_recorrente || false);
      setTipoClienteId(cardData.tipo_cliente_id || '');

      setContractSigned(cardData.contract_signed);
      setContractSignedAt(cardData.contract_signed_at);
      setContractSignedByUser(cardData.signed_by_user_id);
      setResponsavel(cardData.responsavel);

      //


      setCurrentEntity(cardData.entity_id)
      validateDocument(cardData.cpf || ''); //

    }
    buscarOrigens()
    buscarProdutos()
    buscarTiposCliente()
  }, [cardData]);

  useEffect(() => {
    axios.get(`${apiUrlIbge}/estados?orderBy=nome`).then(response => {
      const stateOptions = response.data.map(state => ({
        sigla: state.sigla,
        nome: state.nome,
      }));
      setStates(stateOptions);
    });
  }, []);

  useEffect(() => {
    if (state) {
      axios.get(`${apiUrlIbge}/estados/${state}/municipios?orderBy=nome`).then(response => {
        const cityOptions = response.data.map(city => ({
          id: city.id,
          nome: city.nome,
        }));
        setCities(cityOptions);

        // Seleciona a cidade atual se estiver definida
        if (cardData && cardData.city) {
          const selectedCity = response.data.find(city => city.nome === cardData.city);
          if (selectedCity) {
            setCity(selectedCity.id.toString());

          }
        }
      });
    } else {
      setCities([]);
    }
  }, [state, cardData]);

  const getNameColumnCard = (idColumn) => {
    if (!columnsUser) {
      return 'Dados ainda estão carregando...';
    }
    const nameColumn = columnsUser.find((item) => item.id === idColumn);
    return nameColumn ? nameColumn.name : 'Nome não encontrado';
  };




  function getUserName(userId) {
    // Verifica se o userId é diferente do usuário atual
    if (userId === user.id) {
      return user.username; // Retorna o nome do usuário atual diretamente
    }

    //console.log(userId)
    const userFromList = listAllUsers.find(user => user.id === userId);
    return userFromList ? userFromList.username : 'Unknown';
  }

  // Função para determinar o tipo de documento baseado no produto
  const getTipoDocumentoByProduto = (produto) => {
    if (!produto) return 'PV'; // Padrão se não houver produto

    const produtoLower = produto.toLowerCase();

    if (produtoLower.trim().startsWith('pvsc')) return 'PVSC';
    if (produtoLower.includes('bwood+')) return 'PVB';
    if (produtoLower.includes('rodapé') || produtoLower.includes('rodape')) return 'PVR';
    if (produtoLower.includes('porta interna')) return 'PVPI';
    if (produtoLower.includes('esquadria')) return 'PV';
    if (produtoLower.includes('perfis')) return 'PVW';
    if (produtoLower.includes('amostras')) return 'AM';
    if (produtoLower.includes('acessórios')) return 'PVN';
    if (produtoLower.includes('retrabalho')) return 'RE';
    if (produtoLower.includes('assistência')) return 'PVAT';

    return 'PV'; // Padrão para outros casos
  };

  const validateAndUpdateTemperature = async (newCostValue) => {
  // Converter ambos os valores para número para garantir comparação correta
  const initialValueNumber = Number(initialCostValue) || 0;
  const newValueNumber = Number(newCostValue) || 0;
  
  console.log('Valor inicial (número):', initialValueNumber);
  console.log('Novo valor (número):', newValueNumber);

  // Verifica se o valor inicial era zero e o novo valor é maior que zero
  if (initialValueNumber === 0 && newValueNumber > 0 && cardData.temperatura_card != 0) {
    try {
      console.log('Enviando novo valor de custo:', newCostValue);
      const response = await api.put(`/card/update-temperatura-by-cost/${idCard}`, {
        cost_value: newCostValue
      });
      console.log('Resposta da atualização:', response.data);
    } catch (error) {
      console.error('Erro ao atualizar temperatura do card:', error);
    }
  }
};

  const handleUpdateCard = async (e) => {
    e.preventDefault();
    setIsUpdatingCard(true);
    setError('');

    // Verificação do campo de valor de custo
    if (costValue === '' || costValue === null || costValue === undefined || isNaN(convertToDatabaseFormat(costValue))) {
      setError('O campo de valor de custo deve ser preenchido e deve ser um valor válido.');
      setIsUpdatingCard(false);
      return;
    }

    const phoneError = validateCardPhone(fone, pais);
    if (phoneError) {
      setError(phoneError);
      setIsUpdatingCard(false);
      return;
    }

    const userConfirmed = window.confirm(`Você tem certeza que deseja alterar?`);
    if (!userConfirmed) {
      return;
    }

    const selectedState = states.find((st) => st.sigla === state);
    const selectedCity = cities.find((ct) => ct.id === parseInt(city));

    const cardData = {
      id: idCard,
      name: name.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
      state: pais === 'Brasil' ? (selectedState ? selectedState.sigla : '') : '',
      city: pais === 'Brasil' ? (selectedCity ? selectedCity.nome : '') : '',
      fone,
      email,
      column_id: columnId,
      entity_id: entityId,
      empresa_id: user.empresa_id,
      document_number: documentNumber ? documentNumber : '',
      cost_value: convertToDatabaseFormat(costValue),
      sale_value: convertToDatabaseFormat(saleValue),
      status: statusCard ? statusCard : '',
      origem: origemCard ? origemCard : 'Sem Origem',
      produto: produtoCard ? produtoCard : 'Não informado',
      status_date: statusDateCard ? statusDateCard : null,
      second_document_number: secondDocumentoNumber ? secondDocumentoNumber : '',
      pedido_number: pedidoNumber ? pedidoNumber : '',
      etiqueta_id: idEtiqueta ? idEtiqueta : null,
      cpf: cpf || '',
      endereco: endereco || '',
      participante_id: participanteId || null,
      responsavel: responsavel || '',
      cidade_estado_internacional: pais !== 'Brasil' ? cidadeEstadoInternacional : '',
      pais: pais,
      cliente_recorrente: clienteRecorrente,
      tipo_cliente_id: tipoClienteId || null,
    };

    try {
      const response = await api.post(`/card/update`, cardData);
      const updatedCardData = response.data[0];

      // Validar e atualizar temperatura do card
      await validateAndUpdateTemperature(convertToDatabaseFormat(costValue));

      // Atualizar origem da venda no Faktory se houver número do pedido
      if (pedidoNumber) {
        try {
          const tipoDocumento = getTipoDocumentoByProduto(produtoCard);

          console.log('tipoDocumento:', tipoDocumento);
          await apiUploads.post('/faktory/update-origem-venda', {
            numeroPedido: parseInt(pedidoNumber),
            origem: origemCard,
            tipoDocumento: tipoDocumento
          });
        } catch (error) {
          console.error('Erro ao atualizar origem da venda no Faktory:', error);
        }
      }

      // Comparar alterações e registrar no histórico
      if (tempCardData) {
        const changes = [];

        if (tempCardData.name !== cardData.name) {
          changes.push(`Nome alterado de "${tempCardData.name}" para "${cardData.name}"`);
        }
        if (tempCardData.email !== cardData.email) {
          changes.push(`Email alterado de "${tempCardData.email}" para "${cardData.email}"`);
        }
        if (tempCardData.fone !== cardData.fone) {
          changes.push(`Telefone alterado de "${tempCardData.fone}" para "${cardData.fone}"`);
        }
        if (tempCardData.state !== cardData.state) {
          changes.push(`Estado alterado de "${tempCardData.state}" para "${cardData.state}"`);
        }
        if (tempCardData.city !== cardData.city) {
          changes.push(`Cidade alterada de "${tempCardData.city}" para "${cardData.city}"`);
        }
        if (tempCardData.document_number !== cardData.document_number) {
          changes.push(`PrefWeb alterado de "${tempCardData.document_number}" para "${cardData.document_number}"`);
        }
        if (tempCardData.second_document_number !== cardData.second_document_number) {
          changes.push(`PrefSuite alterado de "${tempCardData.second_document_number}" para "${cardData.second_document_number}"`);
        }
        if (tempCardData.pedido_number !== cardData.pedido_number) {
          changes.push(`Faktory alterado de "${tempCardData.pedido_number}" para "${cardData.pedido_number}"`);
        }
        if (tempCardData.cost_value !== cardData.cost_value) {
          const oldValue = parseFloat(tempCardData.cost_value) || 0;
          const newValue = parseFloat(cardData.cost_value) || 0;
          if (oldValue !== newValue) {
            changes.push(`Valor de custo alterado de "${tempCardData.cost_value}" para "${cardData.cost_value}"`);
          }
        }
        if (tempCardData.sale_value !== cardData.sale_value) {
          const oldValue = parseFloat(tempCardData.sale_value) || 0;
          const newValue = parseFloat(cardData.sale_value) || 0;
          if (oldValue !== newValue) {
            changes.push(`Valor de venda alterado de "${tempCardData.sale_value}" para "${cardData.sale_value}"`);
          }
        }
        if (tempCardData.origem !== cardData.origem) {
          changes.push(`Origem alterada de "${tempCardData.origem}" para "${cardData.origem}"`);
        }
        if (tempCardData.produto !== cardData.produto) {
          changes.push(`Produto alterado de "${tempCardData.produto}" para "${cardData.produto}"`);
        }
        if (tempCardData.cpf !== cardData.cpf) {
          changes.push(`CPF/CNPJ alterado de "${tempCardData.cpf}" para "${cardData.cpf}"`);
        }
        if (tempCardData.endereco !== cardData.endereco) {
          changes.push(`Endereço alterado de "${tempCardData.endereco}" para "${cardData.endereco}"`);
        }
        if (tempCardData.responsavel !== cardData.responsavel) {
          changes.push(`Responsável alterado de "${tempCardData.responsavel}" para "${cardData.responsavel}"`);
        }

        // Registrar cada alteração no histórico
        changes.forEach(change => {
          addHistoricoCardContext(change, idCard, user.id);
        });

        // Limpar dados temporários após salvar
        setTempCardData(null);
      }

      setCards(prevCards => prevCards.map(card => card.card_id === idCard ? { ...card, ...updatedCardData } : card));
      setPreviewSearchCards(prevCards => prevCards.map(card => card.card_id === idCard ? { ...card, ...updatedCardData } : card));
      setListNotifications(prevCards => prevCards.map(card => card.card_id === idCard ? { ...card, ...updatedCardData } : card));

      setOpenCloseUpdateCard(false);
      setIsUpdatingCard(false);

      if (columnId !== currentIdColumn) {
        addHistoricoCardContext(`Coluna alterada para ${getNameColumnCard(columnId)}`, idCard, user.id);
      }

      if (currentEntity !== entityId) {
        addHistoricoCardContext(`Entidade alterada para ${getUserName(parseInt(entityId))}`, idCard, user.id);
      }

    } catch (error) {
      setIsUpdatingCard(false);
      setError('Erro ao atualizar o Card.');
    }
  };


  useEffect(() => {
    if (cardData) {
      setCurrentIdColumn(cardData.column_id);
    }
  }, [cardData]);




  const arquivarCard = async (id, event) => {
    event.stopPropagation();

    // Verifica se o card pode ser arquivado
    if (![5, 8, 9].includes(Number(user.access_level)) && cardData.temperatura_card !== 0) {
      alert("Você não pode arquivar cards de Link Patrocinado!");
      return;
    }

    //console.log('cardData.column_id:', cardData.column_id, typeof cardData.column_id);
    //console.log('editableColumns:', editableColumns);
    const isColumnEditable = editableColumns.some(column => {
      //console.log('Comparing:', Number(column.columnId), Number(cardData.column_id));
      return Number(column.columnId) === Number(cardData.column_id);
    });
    //console.log('isColumnEditable:', isColumnEditable);

    // Exibe um alert e interrompe se a coluna não for editável
    if (!isColumnEditable) {
      alert("Você não pode arquivar este Card nesta coluna!");
      return;
    }


    let motivo = '';
    while (motivo.length < 10 || motivo.length > 60) {
      motivo = prompt('Por favor, insira o motivo para arquivar o card (mínimo de 10 e máximo de 60 caracteres):');
      if (!motivo) {
        alert('Arquivamento cancelado. O motivo é obrigatório.');
        return;
      }

      if (motivo.length < 10) {
        alert('O motivo deve conter no mínimo 10 caracteres.');
      } else if (motivo.length > 60) {
        alert('O motivo deve conter no máximo 60 caracteres.');
      }
    }

    const userConfirmed = window.confirm('Você tem certeza que deseja arquivar este card?');
    if (!userConfirmed) {
      return;
    }

    const arquivadosColumn = columns.find(column => column.name.replace(/\s/g, '') === empresa.coluna_arquivado.replace(/\s/g, ''));

    let columnId = arquivadosColumn ? arquivadosColumn.id : cardData.column_id;


    try {

      const response = await api.post(`/card/update-arquivados`, {

        id,
        status: 'Arquivado',
        columnId: columnId,
        motivoCardArquivado: motivo
      });

      setCards(prevCards => prevCards.map(card => card.card_id === id ? { ...card, ...response.data } : card));
      setPreviewSearchCards(prevCards => prevCards.map(card => card.card_id === id ? { ...card, ...response.data } : card));
      setListNotifications(prevCards => prevCards.map(card => card.card_id === id ? { ...card, ...response.data } : card));
      addHistoricoCardContext(`Card Arquivado: ${motivo}`, cardData.card_id, user.id);
      setOpenCloseUpdateCard(false);
    } catch (error) {
      console.error('Erro ao arquivar o cartão:', error);
    }
  };



  const buscarOrigens = async () => {
    try {
      // const response = await axios.get(`${apiUrl}/card/origens/${user.empresa_id}`);
      const response = await api.get(`/card/origens/${user.empresa_id}`);

      setListOrigens(response.data);

      // apenas adm: Anúncio INSTAGRAM, Anúncio FACEBOOK, Anúncio GOOGLE
    } catch (error) {
      console.error('Erro ao buscar origens:', error);
    }
  };

  const buscarTiposCliente = async () => {
    try {
      const response = await api.get(`/card/tipos-cliente/${user.empresa_id}`);
      setListTiposCliente(response.data);
    } catch (error) {
      console.error('Erro ao buscar tipos de cliente:', error);
    }
  };




  const buscarProdutos = async () => {
    try {
      // const response = await axios.get(`${apiUrl}/card/produtos/${user.empresa_id}`);
      const response = await api.get(`/card/produtos/${user.empresa_id}`);

      setListProdutos(response.data);
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
    }
  };


  const sortedEtiquetas = [...listaEtiquetas].sort((a, b) => a.order - b.order);


  const convertToDatabaseFormat = (value) => {
    if (!value) return 0;
    return parseFloat(value.replace(/\./g, '').replace(',', '.'));
  };




  const validateDocument = (cpf) => {
    if (!cpf) {
      setCpfError(''); // Limpar erro se o campo estiver vazio
      return;
    }

    const cleanCpf = cpf.replace(/[^\d]+/g, '');

    if (cleanCpf.length === 11) {
      // CPF
      if (validateCPF(cleanCpf)) {
        setCpfError(''); // CPF válido
      } else {
        setCpfError('CPF inválido');
      }
    } else if (cleanCpf.length === 14) {
      // CNPJ
      if (validateCNPJ(cleanCpf)) {
        setCpfError(''); // CNPJ válido
      } else {
        setCpfError('CNPJ inválido');
      }
    } else {
      setCpfError('Documento deve ter 11 (CPF) ou 14 dígitos (CNPJ)');
    }
  };

  const validateCPF = (cpf) => {
    let sum = 0;
    let remainder;
    for (let i = 1; i <= 9; i++) sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  };

  const validateCNPJ = (cnpj) => {
    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    let digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;

    length += 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1))) return false;

    return true;
  };





  const handleSaveClient = async () => {
    // Verificar se todos os campos obrigatórios estão preenchidos
    if (!name || !email || !fone || !state || !city || !cpf || cpfError !== '' || !endereco) {
      alert('Por favor, preencha todos os campos obrigatórios e garanta que o CPF/CNPJ seja válido.');
      return;
    }

    try {
      // Chamada para verificar se o cliente já existe pelo CPF/CNPJ
      // const response = await axios.post(`${apiUrl}/card/participantes/create`, {
      const response = await api.post(`/card/participantes/create`, {


        name,
        email,
        telefone: fone,
        endereco,
        tipo: 'Cliente',  // Tipo padrão para o cliente
        state,
        city,
        empresa_id: user.empresa_id,
        entity_id: entityId,
        cpf: cpf,
      });

      alert('Cliente salvo com sucesso!');

    } catch (error) {
      console.error('Erro ao salvar o cliente:', error);
      alert('Erro ao salvar o cliente. Verifique o console para mais detalhes.');
    }
  };






  const handleSearchClient = async () => {
    if (!cpf) {
      alert('Por favor, insira o CPF/CNPJ para buscar o cliente.');
      return;
    }

    try {
      // const response = await axios.get(`${apiUrl}/card/participantes/search`, {
      const response = await api.get(`/card/participantes/search`, {

        params: { cpf },
      });

      if (response.data.success) {
        const cliente = response.data.data;
        setName(sanitizeCardName(cliente.name));
        setEmail(cliente.email);
        setFone(cliente.telefone);
        setEndereco(cliente.endereco);
        setState(cliente.state);


        // Buscar as cidades novamente e selecionar a cidade correta
        axios.get(`${apiUrlIbge}/estados/${cliente.state}/municipios?orderBy=nome`).then(response => {
          const cityOptions = response.data.map(city => ({
            id: city.id,
            nome: city.nome,
          }));
          setCities(cityOptions);

          // Selecionar a cidade correta com base no nome da cidade do cliente
          const selectedCity = response.data.find(city => city.nome === cliente.city);
          if (selectedCity) {
            setCity(selectedCity.id.toString());
          }
        });
      } else {
        alert('Cliente não encontrado.');
      }
    } catch (error) {
      console.error('Erro ao buscar o cliente:', error);
      alert('Erro ao buscar o cliente. Verifique o console para mais detalhes.');
    }
  };

  const loadCardParticipantes = useCallback(async () => {
    if (!idCard) return;
    try {
      const response = await api.get(`/card/card-participantes/${idCard}`);
      setCardParticipantesList(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      setCardParticipantesList([]);
    }
  }, [idCard]);

  const closeParticipantSearchModal = () => {
    participantSearchSelectRef.current = null;
    setParticipantSearchModal(prev => ({ ...prev, open: false }));
  };

  const openParticipantSearchModal = ({
    title = 'Buscar participante',
    emptyText = 'Digite ao menos 2 caracteres para buscar.',
    onSelect,
    excludeIds = [],
  } = {}) => {
    participantSearchSelectRef.current = onSelect || null;
    setParticipantSearchModal({
      open: true,
      title,
      emptyText,
      term: '',
      page: 1,
      limit: 8,
      total: 0,
      totalPages: 0,
      items: [],
      loading: false,
      message: '',
      excludeIds: excludeIds.map((id) => Number(id)),
    });
  };

  const searchParticipantsPaged = useCallback(async (term, page = 1) => {
    const cleanTerm = String(term || '').trim();
    if (cleanTerm.length < 2) {
      setParticipantSearchModal(prev => ({
        ...prev,
        items: [],
        total: 0,
        totalPages: 0,
        page: 1,
        loading: false,
        message: 'Digite ao menos 2 caracteres para buscar.',
      }));
      return;
    }

    setParticipantSearchModal(prev => ({ ...prev, loading: true, message: '' }));
    try {
      const response = await api.get('/card/participantes/search-paged', {
        params: { term: cleanTerm, page, limit: participantSearchModal.limit },
      });
      const data = response.data || {};
      setParticipantSearchModal(prev => {
        const excluded = new Set(prev.excludeIds || []);
        const items = (data.items || []).filter((item) => !excluded.has(Number(item.id)));
        return {
          ...prev,
          items,
          total: Number(data.total || 0),
          totalPages: Number(data.totalPages || 0),
          page: Number(data.page || page),
          limit: Number(data.limit || prev.limit),
          loading: false,
          message: items.length ? '' : 'Nenhum participante encontrado.',
        };
      });
    } catch (error) {
      setParticipantSearchModal(prev => ({
        ...prev,
        items: [],
        total: 0,
        totalPages: 0,
        loading: false,
        message: 'Erro ao buscar participantes.',
      }));
    }
  }, [participantSearchModal.limit]);

  const handleParticipantSearchTermChange = (value) => {
    setParticipantSearchModal(prev => ({
      ...prev,
      term: value,
      page: 1,
      items: value.trim().length >= 2 ? prev.items : [],
      message: value.trim().length >= 2 ? '' : prev.emptyText,
    }));
  };

  const handleParticipantSearchSelect = async (participante) => {
    if (participantSearchSelectRef.current) {
      await participantSearchSelectRef.current(participante);
      closeParticipantSearchModal();
    }
  };

  useEffect(() => {
    if (!participantSearchModal.open) return;
    const term = participantSearchModal.term.trim();
    if (term.length < 2) {
      setParticipantSearchModal(prev => ({
        ...prev,
        items: [],
        total: 0,
        totalPages: 0,
        page: 1,
        loading: false,
        message: prev.emptyText,
      }));
      return;
    }

    const timeout = setTimeout(() => {
      searchParticipantsPaged(term, participantSearchModal.page || 1);
    }, 350);

    return () => clearTimeout(timeout);
  }, [participantSearchModal.open, participantSearchModal.term, participantSearchModal.page, searchParticipantsPaged]);

  const updateNewParticipantForm = (field, value) => {
    setNewParticipantForm(prev => ({
      ...prev,
      [field]: value,
      ...(field === 'state' ? { city: '' } : {}),
    }));
    if (field === 'cpf') {
      setNewParticipantCpfError('');
    }
    setNewParticipantMessage('');
  };

  const getParticipantFormFromCard = () => {
    const selectedCity = cities.find((ct) => String(ct.id) === String(city));
    return {
      ...getEmptyParticipantForm(),
      name: name || cardData?.name || '',
      email: email || cardData?.email || '',
      telefone: pais === 'Brasil'
        ? formatBrazilianPhoneInput(fone || cardData?.fone || '')
        : (fone || cardData?.fone || ''),
      endereco: endereco || cardData?.endereco || '',
      cpf: cpf || cardData?.cpf || '',
      state: pais === 'Brasil' ? (state || cardData?.state || '') : '',
      city: pais === 'Brasil'
        ? (selectedCity?.nome || cardData?.city || '')
        : (cidadeEstadoInternacional || cardData?.cidade_estado_internacional || ''),
    };
  };

  const openCreateParticipantModal = () => {
    setNewParticipantForm(getParticipantFormFromCard());
    setNewParticipantMessage('');
    setNewParticipantCpfError('');
    setCreateParticipantOpen(true);
  };

  const validateNewParticipantDocument = () => {
    const documentValue = newParticipantForm.cpf.replace(/[^\d]+/g, '');
    if (!documentValue) {
      setNewParticipantCpfError('');
      return true;
    }
    if (documentValue.length === 11 && validateCPF(documentValue)) {
      setNewParticipantCpfError('');
      return true;
    }
    if (documentValue.length === 14 && validateCNPJ(documentValue)) {
      setNewParticipantCpfError('');
      return true;
    }
    setNewParticipantCpfError('CPF/CNPJ invalido');
    return false;
  };

  const handleCreateParticipantFromCard = async (event) => {
    event.preventDefault();
    if (!newParticipantForm.name.trim()) {
      setNewParticipantMessage('Informe o nome do participante.');
      return;
    }
    if (!validateNewParticipantDocument()) {
      return;
    }

    setNewParticipantSaving(true);
    setNewParticipantMessage('');
    try {
      await api.post('/card/participantes/create', {
        ...newParticipantForm,
        name: newParticipantForm.name.trim(),
        email: newParticipantForm.email.trim(),
        telefone: newParticipantForm.telefone.trim(),
        endereco: newParticipantForm.endereco.trim(),
        cpf: newParticipantForm.cpf.trim(),
        empresa_id: empresa?.id || user.empresa_id,
        entity_id: user.id,
      });
      setNewParticipantForm(getEmptyParticipantForm());
      setCreateParticipantOpen(false);
      setCardParticipantesMessage('Participante criado.');
    } catch (error) {
      setNewParticipantMessage(error.response?.data?.error || error.response?.data?.message || 'Erro ao criar participante.');
    } finally {
      setNewParticipantSaving(false);
    }
  };

  const handleAddCardParticipante = async (participant) => {
    const participanteIdToAdd = participant?.id || participant?.participante_id;
    if (!participanteIdToAdd) {
      setCardParticipantesMessage('Selecione um participante.');
      return;
    }
    setCardParticipantesMessage('');
    try {
      await api.post(`/card/card-participantes/${idCard}`, {
        participante_id: participanteIdToAdd,
        role: 'participante',
        is_primary: true,
      });
      await loadCardParticipantes();
      closeParticipantSearchModal();
      setCardParticipantesMessage('Participante adicionado.');
    } catch (error) {
      setCardParticipantesMessage(error.response?.data?.message || error.response?.data?.error || 'Erro ao adicionar participante.');
    }
  };

  const handleRemoveCardParticipante = async (item) => {
    setCardParticipantesMessage('');
    try {
      await api.delete(`/card/card-participantes/${idCard}/${item.participante_id}/${item.role}`);
      await loadCardParticipantes();
      setCardParticipantesMessage('Participante removido.');
    } catch (error) {
      setCardParticipantesMessage(error.response?.data?.message || error.response?.data?.error || 'Erro ao remover participante.');
    }
  };

  useEffect(() => {
    loadCardParticipantes();
  }, [loadCardParticipantes]);






  const handleSignContract = async () => {
    const confirmAction = window.confirm(
      contractSigned
        ? "Deseja desmarcar este contrato como assinado?"
        : "Deseja marcar este contrato como assinado?"
    );

    if (confirmAction) {
      try {
        // const response = await axios.post(`${apiUrl}/card/update-contract-status`, {
        const response = await api.post(`/card/update-contract-status`, {

          cardId: idCard,
          contractSigned: !contractSigned, // Inverte o estado da assinatura
          userId: user.id // Define quem assinou o contrato
        });

        const { contract_signed, contract_signed_at, signed_by_user_id } = response.data;

        // console.log(contract_signed, contract_signed_at, signed_by_user_id)

        if (true) {
          setContractSigned(contract_signed); // Atualiza o estado
          setContractSignedAt(new Date(contract_signed_at)); // Atualiza a data de assinatura
          setContractSignedByUser(signed_by_user_id); // Define quem assinou o contrato
          alert("Status do contrato atualizado com sucesso!");
        } else {
          alert("Erro ao atualizar o status do contrato.");
        }
      } catch (error) {
        console.error("Erro ao atualizar o status do contrato:", error);
        alert("Erro ao atualizar o status do contrato.");
      }
    }
  };



  const getUsernameById = (entityId) => {

    if (!user) {
      return 'Erro: Dados necessários não estão disponíveis.';
    }

    const entidade = listAllUsers.find(afilhado => afilhado.id === entityId);
    if (entidade && entidade.username) {
      return entidade.username;
    }

    if (entityId === user.id) {
      return user.username;
    }

    return 'id não encontrado';
  };







  // Função de controle da origem (otimizada)
  const handleOrigemChange = (e) => {
    const newOrigem = e.target.value;

    // Verifica permissão
    if ([5, 8, 9].includes(Number(user.access_level)) || !origemCard || origemCard.trim() === '' || origemCard === 'Sem Origem') {
      const confirmado = window.confirm(`Você tem certeza que deseja alterar a origem para "${newOrigem}"?`);
      if (!confirmado) {
        e.target.value = origemCard;
        return;
      }
      setOrigemCard(newOrigem);
    } else {
      alert("Você não tem permissão para alterar a origem.");
    }
  };

  // Função de controle do Faktory (otimizada)
  const handleFaktoryChange = (e) => {
    const newFaktory = e.target.value;

    if ([5, 8, 9].includes(Number(user.access_level))) {
      setPedidoNumber(newFaktory);
    } else {
      alert("Você não tem permissão para alterar o campo Faktory.");
    }
  };

  // Adicionar função para formatar CPF/CNPJ
  const formatDocument = (value) => {
    const numbers = value.replace(/\D/g, '');

    if (numbers.length <= 11) {
      // Formatação de CPF
      return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      // Formatação de CNPJ
      return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
  };

  return (
    <div className='update-card-modal'>
      <div className='update-card-container-update'>
        <div className='header-update-card-container'>
          <label>Oportunidade</label>
        </div>
        <div className="update-card-form-container">


          <label style={{ display: 'none' }} htmlFor="cpf-cnpj" className='update-card-label-input'>Assinatura de Contrato:</label>


          {/* Botão de Assinar Contrato */}
          <div style={{ display: 'none' }} className='sign-contract-container'>


            <button
              className={`sign-contract-button ${contractSigned ? 'true' : 'false'}`}
              onClick={handleSignContract}
            >
              {contractSigned ? 'Assinado' : 'Não Assinado'}
            </button>

            {contractSignedByUser && contractSignedAt && (
              <div className="signed-info">
                Atualizado por: {getUsernameById(contractSignedByUser)} em {new Date(contractSignedAt).toLocaleDateString('pt-BR')}
              </div>
            )}



          </div>

          <form className="update-card-form" onSubmit={handleUpdateCard}>














            <label style={{ display: '' }} htmlFor="cpf-cnpj" className='update-card-label-input'>CPF ou CNPJ do Cliente:</label>

            <div style={{ display: '' }} className='cpf-btn-container'>



              <input
                id="cpf-cnpj"
                className="update-card-input"
                type="text"
                value={cpf}
                placeholder="Digite o CPF ou CNPJ"
                onChange={(e) => {
                  const cleanValue = e.target.value.replace(/\D/g, ''); // mantém só números
                  setCpf(cleanValue);
                  validateDocument(cleanValue);
                }}
                maxLength={18} // Pode manter esse valor ou ajustar conforme desejar
              />

              <button
                className="save-client-button"
                type="button" // Adicione isso
                onClick={handleSaveClient}
                disabled={cpfError !== '' || cpf === ''}  // Desabilita o botão se o CPF/CNPJ não for válido ou estiver vazio
              >
                Salvar Cliente
              </button>

              <button
                className="search-client-button"
                type="button" // Adicione isso
                onClick={handleSearchClient}
              >
                Buscar Cliente
              </button>



            </div>

            {cpfError && <div className="update-card-error-message">{cpfError}</div>}

            <label htmlFor="username" className='update-card-label-input'>Nome do Cliente:</label>
            <input id="username" className="update-card-input" type="text" value={name} onChange={(e) => setName(sanitizeCardName(e.target.value))} />


            <label htmlFor="endereco" className='update-card-label-input'>Endereço de Entrega:</label>
            <input id="endereco" className="update-card-input" type="text" value={endereco} onChange={(e) => setEndereco(e.target.value)} />


            <label htmlFor="pais" className='update-card-label-input'>País:</label>
            <div className='select-cidade-estado-container'>
              <select id="pais" className="select-estado-cidade" value={pais} onChange={(e) => setPais(e.target.value)}>
                <option value="Brasil">Brasil</option>
                <option value="Paraguai">Paraguai</option>
              </select>
            </div>

            {pais === 'Brasil' ? (
              <>
                <label htmlFor="city-state" className='update-card-label-input'>Estado:</label>
                <div className='select-cidade-estado-container'>
                  <select id="state" className="select-estado-cidade" value={state} onChange={(e) => setState(e.target.value)}>
                    <option value="">Selecione o estado</option>
                    {states.map(state => (
                      <option key={state.sigla} value={state.sigla}>{state.nome}</option>
                    ))}
                  </select>
                </div>


                <label htmlFor="city-state" className='update-card-label-input'>Cidade:</label>

                <div className='select-cidade-estado-container'>

                  <select id="city" className="select-estado-cidade" value={city} onChange={(e) => setCity(e.target.value)} disabled={!state}>
                    <option value="">Selecione a cidade</option>
                    {cities.map(city => (
                      <option key={city.id} value={city.id}>{city.nome}</option>
                    ))}
                  </select>
                </div>
              </>
            ) : (
              <>
                <label htmlFor="cidadeEstadoInternacional" className='update-card-label-input'>Cidade / Estado:</label>
                <input id="cidadeEstadoInternacional" className="update-card-input" type="text" placeholder="Ex: Ciudad del Este - Alto Paraná" value={cidadeEstadoInternacional} onChange={(e) => setCidadeEstadoInternacional(e.target.value)} />
              </>
            )}

            <label htmlFor="fone" className='update-card-label-input'>Fone:</label>
            <input id="fone" className="update-card-input" type="tel" inputMode="tel" value={fone} onChange={(e) => setFone(e.target.value)} />

            <label htmlFor="email" className='update-card-label-input'>Email:</label>
            <input id="email" className="update-card-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

            <label htmlFor="documentNumber" className='update-card-label-input'>PrefWeb:</label>
            <input id="documentNumber" className="update-card-input" type="text" value={documentNumber} onChange={(e) => setDocumentNumber(e.target.value)} />

            <label htmlFor="documentNumber" className='update-card-label-input'>PrefSuite:</label>
            <input id="documentNumber" className="update-card-input" type="text" value={secondDocumentoNumber} onChange={(e) => setSecondDocumentNumber(e.target.value)} />


            <label htmlFor="documentNumber" className='update-card-label-input'>Faktory:</label>
            <input
              id="documentNumber"
              className="update-card-input"
              type="text"
              value={pedidoNumber}
              onChange={handleFaktoryChange}
              disabled={![5, 8, 9].includes(Number(user.access_level))}
            />


            <label htmlFor="costValue" className='update-card-label-input'>Valor de Custo:</label>
            <input
              id="costValue"
              className="update-card-input"
              type="text"
              value={costValue}
              onChange={(e) => setCostValue(e.target.value)}
              disabled={isCardPart(cardData)}
              title={isCardPart(cardData) ? 'O valor só pode ser alterado no card principal.' : ''}
            />

            <label htmlFor="saleValue" className='update-card-label-input'>Valor de Venda:</label>
            <input
              id="saleValue"
              className="update-card-input"
              type="text"
              value={saleValue}
              onChange={(e) => setSaleValue(e.target.value)}
              disabled={isCardPart(cardData)}
              title={isCardPart(cardData) ? 'O valor só pode ser alterado no card principal.' : ''}
            />


            <label htmlFor="responsavel" className='update-card-label-input'>Representante Responsável:</label>
            <input
              id="responsavel"
              className="update-card-input"
              type="text"
              value={responsavel}
              onChange={(e) => setResponsavel(e.target.value)}
            />


            <label htmlFor="city-state" className='update-card-label-input'>Origem:</label>
            <div className='select-cidade-estado-container'>
              <select
                id="origem"
                className="select-estado-cidade"
                value={origemCard}
                onChange={handleOrigemChange}
                disabled={!([5, 8, 9].includes(Number(user.access_level)) || !origemCard || origemCard.trim() === '' || origemCard === 'Sem Origem')}
              >
                <option value="">Selecione a origem</option>
                {listOrigens
                  .filter(origem => {
                    // Filtrar apenas se não for admin
                    if (![5, 8, 9].includes(Number(user.access_level))) {
                      return (
                        origem.name !== 'Anúncio INSTAGRAM' &&
                        origem.name !== 'Anúncio FACEBOOK' &&
                        origem.name !== 'Anúncio GOOGLE' &&
                        origem.name !== 'WhatsApp MKT Bazze' &&
                        origem.name !== 'Recomendação MKT' &&
                        origem.name !== 'Cliente Recorrente MKT' &&
                        origem.name !== 'Site Bazze'
                      );
                    }
                    return true; // Se for admin, mostra tudo
                  })
                  .map(origem => (
                    <option key={origem.id} value={origem.name}>{origem.name}</option>
                  ))}
              </select>
            </div>



            <label htmlFor="city-state" className='update-card-label-input'>Produto:</label>

            <div className='select-cidade-estado-container'>
              <select id="produto" className="select-estado-cidade" value={produtoCard} onChange={(e) => setProdutoCard(e.target.value)}  >
                <option value="">Selecione o produto</option>
                {listProdutos.map(produto => (
                  <option key={produto.id} value={produto.name}>{produto.name}</option>
                ))}
              </select>
            </div>


            <label htmlFor="clienteRecorrente" className='update-card-label-input'>Cliente Recorrente:</label>
            <div className='select-cidade-estado-container'>
              <select id="clienteRecorrente" className="select-estado-cidade" value={clienteRecorrente} onChange={(e) => setClienteRecorrente(e.target.value === 'true')}>
                <option value="false">Não</option>
                <option value="true">Sim</option>
              </select>
            </div>

            <label htmlFor="tipoCliente" className='update-card-label-input'>Tipo de Cliente:</label>
            <div className='select-cidade-estado-container'>
              <select id="tipoCliente" className="select-estado-cidade" value={tipoClienteId} onChange={(e) => setTipoClienteId(e.target.value)}>
                <option value="">
                  {listTiposCliente.length ? 'Selecione o tipo' : 'Cadastre um tipo em Configurações'}
                </option>
                {listTiposCliente.map(tipo => (
                  <option key={tipo.id} value={tipo.id}>{tipo.name}</option>
                ))}
              </select>
            </div>



            <label htmlFor="cardParticipanteId" className='update-card-label-input'>Relacionamentos do Card:</label>
            <div className="update-card-relacionamentos-box">
              <div className="update-card-relacionamentos-topbar">
                <button type="button" onClick={openCreateParticipantModal}>Criar participante</button>
              </div>

              <div className="update-card-relacionamentos-section">
                <WhatsappZapiContactPicker
                  cardId={idCard}
                  onOpenParticipantSearch={openParticipantSearchModal}
                />
              </div>

              <div className="update-card-relacionamentos-section">
                <div className="update-card-relacionamentos-header">
                  <span>Empresa Participante</span>
                </div>

                {cardParticipantesList.filter((item) => item.role !== 'contato' && item.role !== 'contato_principal').length === 0 && (
                  <span className="update-card-participantes-empty">Nenhuma empresa participante vinculada.</span>
                )}

                {cardParticipantesList.filter((item) => item.role !== 'contato' && item.role !== 'contato_principal').map((item) => {
                  const roleLabel = cardParticipanteRoles.find((role) => role.value === item.role)?.label || item.role;
                  return (
                    <div key={`${item.participante_id}-${item.role}`} className="update-card-participantes-item">
                      <div className="update-card-participantes-info">
                        <strong>{getParticipantDisplayName(item)}</strong>
                        <span>{getParticipantDisplayMeta(item)}</span>
                        <small>{roleLabel}</small>
                      </div>
                      <button type="button" onClick={() => handleRemoveCardParticipante(item)}>Remover</button>
                    </div>
                  );
                })}

                <div className="update-card-participantes-add">
                  <input
                    id="cardParticipanteId"
                    type="text"
                    readOnly
                    value=""
                    onClick={() => openParticipantSearchModal({
                      title: 'Buscar empresa participante',
                      emptyText: 'Digite ao menos 2 caracteres para buscar empresas participantes.',
                      excludeIds: cardParticipantesList
                        .filter((item) => item.role !== 'contato' && item.role !== 'contato_principal')
                        .map((item) => item.participante_id),
                      onSelect: handleAddCardParticipante,
                    })}
                    placeholder="Buscar empresa participante"
                  />
                </div>

                {cardParticipantesMessage && (
                  <span className="update-card-participantes-message">{cardParticipantesMessage}</span>
                )}
              </div>
            </div>



            <label htmlFor="city-state" className='update-card-label-input'>Entidade:</label>


            <div className='select-cidade-estado-container'>
              <select id="produto" className="select-estado-cidade" value={entityId} onChange={(e) => setEntityId(e.target.value)}  >
                <option value="">Alterar Entidade</option>
                {listAllUsers.map(produto => (
                  <option key={produto.id} value={produto.id}>{produto.username}</option>
                ))}
              </select>
            </div>

            <div className='module-esquadrias-column'>
              <label htmlFor="previsaoVistoriaPos" className='modulo-esquadrias-label-input'>Alterar a Data de Status manualmente:</label>
              <input id="previsaoVistoriaPos" className="modulo-esquadrias-input" type="date" name="previsaoVistoriaPos" value={statusDateCard} onChange={(e) => setStatusDateCard(e.target.value)} />
            </div>


            <label htmlFor="columnId" className='update-card-label-input'>Column ID: {columnId}</label>
            <label htmlFor="idCard" className='update-card-label-input'>Card ID: {idCard}</label>
          </form>
        </div>
        {participantSearchModal.open && (
          <div className="update-card-participant-search-overlay" onMouseDown={(event) => event.target === event.currentTarget && closeParticipantSearchModal()}>
            <div className="update-card-participant-search-modal">
              <div className="update-card-participant-search-header">
                <h3>{participantSearchModal.title}</h3>
                <button type="button" onClick={closeParticipantSearchModal} aria-label="Fechar">X</button>
              </div>

              <div className="update-card-participant-search-body">
                <input
                  type="text"
                  autoFocus
                  value={participantSearchModal.term}
                  onChange={(event) => handleParticipantSearchTermChange(event.target.value)}
                  placeholder="Digite nome, telefone, email ou CPF/CNPJ"
                />

                {participantSearchModal.loading && (
                  <span className="update-card-participant-search-message">Buscando...</span>
                )}

                {!participantSearchModal.loading && participantSearchModal.message && (
                  <span className="update-card-participant-search-message">{participantSearchModal.message}</span>
                )}

                {!participantSearchModal.loading && participantSearchModal.items.length > 0 && (
                  <div className="update-card-participant-search-list">
                    {participantSearchModal.items.map((participante) => (
                      <button type="button" key={participante.id} onClick={() => handleParticipantSearchSelect(participante)}>
                        <strong>{participante.name}</strong>
                        <span>{participante.telefone || participante.email || participante.cpf || 'Sem telefone/email'}</span>
                        <small>{participante.tipo || 'Participante'}</small>
                      </button>
                    ))}
                  </div>
                )}

                <div className="update-card-participant-search-footer">
                  <span>
                    {participantSearchModal.total > 0
                      ? `${participantSearchModal.total} resultado(s)`
                      : ' '}
                  </span>
                  <div>
                    <button
                      type="button"
                      disabled={participantSearchModal.page <= 1 || participantSearchModal.loading}
                      onClick={() => setParticipantSearchModal(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
                    >
                      Anterior
                    </button>
                    <span>{participantSearchModal.page}/{participantSearchModal.totalPages || 1}</span>
                    <button
                      type="button"
                      disabled={participantSearchModal.page >= participantSearchModal.totalPages || participantSearchModal.loading}
                      onClick={() => setParticipantSearchModal(prev => ({ ...prev, page: prev.page + 1 }))}
                    >
                      Proxima
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {createParticipantOpen && (
          <div className="update-card-participante-modal-overlay" onMouseDown={(event) => event.target === event.currentTarget && setCreateParticipantOpen(false)}>
            <div className="update-card-participante-modal">
              <div className="update-card-participante-modal-header">
                <h3>Novo participante</h3>
                <button type="button" onClick={() => setCreateParticipantOpen(false)}>X</button>
              </div>

              <form className="update-card-participante-modal-form" onSubmit={handleCreateParticipantFromCard}>
                <label>Nome:</label>
                <input
                  type="text"
                  value={newParticipantForm.name}
                  onChange={(event) => updateNewParticipantForm('name', event.target.value)}
                  placeholder="Nome do participante"
                />

                <label>Telefone:</label>
                <input
                  type="text"
                  value={newParticipantForm.telefone}
                  onChange={(event) => updateNewParticipantForm(
                    'telefone',
                    pais === 'Brasil' ? formatBrazilianPhoneInput(event.target.value) : event.target.value,
                  )}
                  placeholder="Telefone"
                />

                <label>Email:</label>
                <input
                  type="email"
                  value={newParticipantForm.email}
                  onChange={(event) => updateNewParticipantForm('email', event.target.value)}
                  placeholder="Email"
                />

                <label>CPF/CNPJ:</label>
                <input
                  type="text"
                  value={newParticipantForm.cpf}
                  onChange={(event) => updateNewParticipantForm('cpf', event.target.value)}
                  onBlur={validateNewParticipantDocument}
                  placeholder="CPF ou CNPJ"
                />
                {newParticipantCpfError && <span className="update-card-participante-modal-error">{newParticipantCpfError}</span>}

                <label>Tipo:</label>
                <select
                  value={newParticipantForm.tipo}
                  onChange={(event) => updateNewParticipantForm('tipo', event.target.value)}
                >
                  <option value="Cliente">Cliente</option>
                  <option value="Arquiteto">Arquiteto</option>
                  <option value="Construtora">Construtora</option>
                  <option value="Construtor">Construtor</option>
                  <option value="Fornecedor">Fornecedor</option>
                  <option value="Parceiro">Parceiro</option>
                  <option value="Colaborador">Colaborador</option>
                  <option value="Investidor">Investidor</option>
                  <option value="Outros">Outros</option>
                </select>

                {newParticipantMessage && <span className="update-card-participante-modal-message">{newParticipantMessage}</span>}

                <div className="update-card-participante-modal-actions">
                  <button type="button" onClick={() => setCreateParticipantOpen(false)} disabled={newParticipantSaving}>Cancelar</button>
                  <button type="submit" disabled={newParticipantSaving}>{newParticipantSaving ? 'Salvando...' : 'Criar participante'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {error && <div className="update-card-error-message">{error}</div>}

        <div className='update-card-footer'>
          <button className="update-card-close-button" onClick={(event) => arquivarCard(cardData.card_id, event)}>Arquivar</button>
          <button className="update-card-close-button" onClick={() => setOpenCloseUpdateCard(false)}>Cancelar</button>
          <button style={{ backgroundColor: !isUpdatingCard ? '' : 'dodgerblue' }} type="submit" className="update-card-button" onClick={handleUpdateCard} disabled={!isUpdatingCard}>Atualizar Card</button>
        </div>
      </div>
    </div>
  );
}

export default UpdateCard;
